@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Idaho</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <h3 class="axis-h5">UM Coverage:</h3>
      <!-- UM Radio Group level one -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[0].formControlName)?.value === null ||
              reactiveForm.get(controls[0].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span class="axis-error-block">Please select an option.</span>
            }
          }
        </div>
      }

      <!-- UM Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UM Min Limits dropdown read-only -->
      @if ((baseRules?.["UM_SplitMinLimits_DropDown"] || "").includes("readonly")) {
      <div class="axis-grid">
        <div class="axis-col-sm-6 axis-col-md-6">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ controls[6].label }}</label>
            <div id="um_splitminlimits_25k_50k-pdffield-idaho">{{ controls[6].data[0].name }}</div>
          </div>
        </div>
      </div>
      }
      @if ((baseRules?.["UM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
      <div class="axis-grid">
        <div class="axis-col-sm-6 axis-col-md-6">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ controls[7].label }}</label>
            <div id="um_combinedsingleminlimit_50k-pdffield-idaho">{{ controls[7].data[0].name }}</div>
          </div>
        </div>
      </div>
      }
      <!-- UM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 4; track $index) {
          @if (control.formControlName.startsWith("UM") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <h3 class="axis-h5">UIM Coverage:</h3>
      <!-- UIM Radio group level one -->
      @if (controls?.length >= 3) {
        <div
          class="axis-form-group _mt-large"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[2].formControlName)?.value === null ||
              reactiveForm.get(controls[2].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span class="axis-error-block">Please select an option.</span>
            }
          }
        </div>
      }

      <!-- UIM Radio group level two -->
      @if (controls?.length >= 4) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required':
              reactiveForm.get(controls[3].formControlName)?.value === null ||
              reactiveForm.get(controls[3].formControlName)?.value === '',
            'has-axis-error':
              reactiveForm.get(controls[3].formControlName)?.touched &&
              reactiveForm.get(controls[3].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
            @for (control of controls[3].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[3].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[3].formControlName)?.touched) {
              @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                <span class="axis-error-block">Please select an option.</span>
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UIM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 4; track $index) {
          @if (control.formControlName.startsWith("UIM") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <!-- UIM Min Limits dropdown read-only -->
      @if ((baseRules?.["UIM_SplitMinLimits_DropDown"] || "").includes("readonly")) {
      <div class="axis-grid">
        <div class="axis-col-sm-6 axis-col-md-6">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ controls[10].label }}</label>
            <div id="uim_splitminlimits_50k_100k-pdffield-idaho">{{ controls[10].data[0].name }}</div>
          </div>
        </div>
      </div>
      }
      @if ((baseRules?.["UIM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
      <div class="axis-grid">
        <div class="axis-col-sm-6 axis-col-md-6">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ controls[11].label }}</label>
            <div id="uim_combinedsingleminlimit_50k-pdffield-idaho">{{ controls[11].data[0].name }}</div>
          </div>
        </div>
      </div>
      }
      
    </form>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Idaho</h2>

  <!-- Reject texts -->
  @if (baseRules?.Reject_LevelOne_UM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
    </div>
  }

  @if (baseRules?.Reject_LevelOne_UIM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_UIM_Text }}
      </label>
    </div>
  }

  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 4; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
}
